import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=eaf00756"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaf00756')) {
      api.createRecord('eaf00756', component.options)
    } else {
      api.reload('eaf00756', component.options)
    }
    module.hot.accept("./Phone.vue?vue&type=template&id=eaf00756", function () {
      api.rerender('eaf00756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/Phone.vue"
export default component.exports